import {
  Box,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import React from "react";
import { FooterLogo } from "../../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{ backgroundColor: "primary.main", color: "#FFFFFF", mt: 5, py: 5 }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{
          md: 4, xs: 1
        }} sx={{
          display: "flex",
          justifyContent: {
            xs: "center",
            sm: "center",
            md: "space-between",
          },
        }}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={FooterLogo}
                alt="AIM microBiome"
                style={{ height: 70, marginRight: 8 }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#FFFFFF",
                    fontSize: "28px",
                  }}
                >
                  AIM microBiome
                </Typography>
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: 500,
                    marginLeft: 1,
                    mt: -0.4,
                    textAlign: 'center',
                    mr: 1.5
                  }}
                >
                  Gut Health, Whole Health
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" mt={2} sx={{
              color: "#FFFFFF",
              fontSize: "22px",
              fontWeight: 500,
            }}>
              {/* Lorem ipsum dolor sit amet consectetur. Nisl proin porttitor odio
              amet ut fringilla. Interdum eget proin enim tincidunt. Tortor vitae
              sed id aliquam felis non. Sed et cursus diam a odio.Sed et cursus
              diam a odio. */}
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, sm: 3, md: 2 }}>
            <Typography
              sx={{
                fontWeight: 600,
                color: "#FFFFFF",
                fontSize: "20px",
                marginBottom: 2,
                fontFamily: "Poppins",
              }}
            >
              Quick Links
            </Typography>
            {[
              { label: "Home", path: "/home" },
              { label: "Services", path: "/services" },
              { label: "Appointment", path: "/book-appointment" },
              { label: "Contact", path: "/contact-us" }
            ].map((link) => (
              <Typography key={link.label} mt={1} sx={{
                fontSize: "20px",
                fontWeight: 500,
                ml: {
                  xs: 2,
                  md: 0
                }
              }}>
                <Typography onClick={() => {
                  if (link.label === "Appointment") {
                    window.open("https://aimmicrobiome.practicebetter.io/#/67b154d6926207b7c4e8528a/bookings?step=services", "_blank");
                  } else if (link.label === "Client Portal") {
                    window.open("https://aimmicrobiome.practicebetter.io/#/signin", "_blank");
                  } else {
                    navigate(link.path);
                  }
                }} style={{ color: "#FFFFFF", textDecoration: "none", cursor: "pointer" }}>
                  {link.label}
                </Typography>
              </Typography>
            ))}
          </Grid>

          <Grid size={{ xs: 6, sm: 3, md: 2 }}>
            <Typography
              sx={{
                fontWeight: 600,
                color: "#FFFFFF",
                fontSize: "20px",
                marginBottom: 2,
                fontFamily: "Poppins",
              }}
            >
              Quick Links
            </Typography>
            {[
              { label: "AIMm Team", path: "/teams" },
              { label: "AIMm Blog", path: "/aimm-blog" },
              { label: "AIMm Store", path: "/home" },
              { label: "AIMm Portal", path: "/aimm-blog" }
            ].map((link) => (
              <Typography key={link.label} sx={{
                fontSize: "20px",
                fontWeight: 500,
                mt: 1,
                ml: {
                  xs: 2,
                  md: 0
                }
              }}>
                <Typography onClick={() => {
                  if (link.label === "AIMm Portal") {
                    window.open("https://aimmicrobiome.practicebetter.io/#/signin", "_blank");
                  } else if (link.label == "AIMm Store") {
                    window.open("https://us.fullscript.com/welcome/smirza1741548876", "_blank");
                  } else {
                    navigate(link.path)
                  }
                }} style={{ color: "#FFFFFF", textDecoration: "none", cursor: "pointer" }}>
                  {link.label}
                </Typography>
              </Typography>
            ))}
          </Grid>
        </Grid>
        <Box
          sx={{
            textAlign: "start",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 4,
            pt: 2,
            borderTop: "1px solid rgba(255, 255, 255, 0.2)"
          }}
        >
          <Typography variant="body2">(c) 2025 All copyrights reserved by AIM Microbiome, LLC.          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 3 }}>
            <a href="https://www.facebook.com/profile.php?id=61577681220873" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
              <FacebookIcon sx={{ fontSize: 32 }} />
            </a>
            <a href="https://www.instagram.com/aimmicrobiome1/?fbclid=IwY2xjawLOB_hleHRuA2FlbQIxMQBicmlkETFzdDdWMHlKU2Y1RkpTc1M1AR6bJRa8Ng1nXEPe9OsY0kT7KEotgXGhxYnNsbuDLjxjTTXlDi_ai9AF7qscXw_aem_y-7xZ7yPvAPQEwlywJJXiQ" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
              <InstagramIcon sx={{ fontSize: 32 }} />
            </a>
            <a href="https://www.linkedin.com/company/aim-microbiome/?viewAsMember=true" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
              <LinkedInIcon sx={{ fontSize: 32 }} />
            </a>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
